export const columnsExpediente = [
    {
        title: "Número de expediente",
        dataIndex: "expediente",
        key: "expediente",
        width: 10,
    },
    {
        title: "Juzgado",
        dataIndex: "juzgado",
        key: "juzgado",
        width: 20,
    },
    {
        title: "Actor",
        dataIndex: "actor",
        key: "actor",
        width: 15,
    },
    {
        title: "Demandado",
        dataIndex: "demandado",
        key: "demandado",
        width: 15,
    }
];